import React from 'react'

const Loader = () => {
  return (
    <div className='loader'>
        <div className='loader__image'>
<div className="center_loader" id="preloader"><div className="wave" /><div className="wave" /><div className="wave" /><div className="wave" /><div className="wave" /><div className="wave" /><div className="wave" /><div className="wave" /><div className="wave" /><div className="wave" /></div>
        </div>
    </div>
  )
}

export default Loader
